import { Combobox, Datepicker, HookFormResolver } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { Row } from '@dec/shared';
import { useGetAllTaxes } from 'app/modules/taxes/hooks/useTaxes';
import { label } from 'app/modules/taxes/TaxOperation/translation';
import { useTranslation } from 'react-i18next';

import { factoryYup } from '../../../core/factory-yup';
const yup = factoryYup();

export const FormSearchStatistics = ({
  nameForm,
  onSubmit,
  children
}: {
  nameForm: string;
  onSubmit: any;
  children: any;
}) => {
  const { t } = useTranslation();
  const { data: taxes, loading: loadingTaxes, error: errorTaxes } = useGetAllTaxes();

  if (loadingTaxes || errorTaxes) {
    return <></>;
  }

  const labelCode = t('collections.label.code');

  const listStatus = [
    {
      id: 'started',
      name: t('collections.status.started')
    },
    {
      id: 'ended',
      name: t('collections.status.ended')
    }
  ];
  const labelStatus = t('taxreturn-report.label.taxreturnState');
  return (
    <>
      <HookFormResolver nameForm={nameForm} onSubmit={onSubmit}>
        {({ reset, setValue, control, watch }: HookFormMethods) => {
          return (
            <>
              <Row>
                <div className="col-12 col-md-6 col-lg-3">
                  <Datepicker label={t('common.label.dateFrom')} name="dateFrom" />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <Datepicker label={t('common.label.dateTo')} name="dateTo" />
                </div>
                <div className="col-12 col-lg-6">
                  <Combobox label={label('tax')} name="tax" display="name" code="id" data={taxes} />
                </div>
              </Row>

              {children(reset)}
            </>
          );
        }}
      </HookFormResolver>
    </>
  );
};
